import { TemplateModel } from '@/components/ui';

import { dateFormatter, highConfidenceValidator } from './common.ts';

export const NDA: TemplateModel = {
  fields: [
    {
      id: 'first_party_name',
      type: 'single-value',
      name: 'First party name',
      promptHint: 'The name of the 1st party representative. First and last name.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'first_party_company',
      type: 'single-value',
      name: 'First Party Company',
      promptHint: 'The name of the 1st party company.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'first_party_signed_date',
      type: 'single-value',
      name: 'First party signature date',
      promptHint: 'The date of signature of the 1st party',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'first_party_address',
      type: 'single-value',
      name: 'First party address',
      promptHint: 'The full address of the first party',
      validators: [highConfidenceValidator],
    },
    {
      id: 'second_party_name',
      type: 'single-value',
      name: 'Second party name',
      promptHint: 'The name of the 2nd party representative. First and last name.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'second_party_company',
      type: 'single-value',
      name: 'Second Party Company',
      promptHint: 'The name of the 2nd party company.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'second_party_signed_date',
      type: 'single-value',
      name: 'Second party signature date',
      promptHint: 'The date of signature of the 2nd party',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'second_party_address',
      type: 'single-value',
      name: 'Second party address',
      promptHint: 'The full address of the second party',
      validators: [highConfidenceValidator],
    },
  ],
  sampleDocuments: ['https://public.cradl.ai/sample_documents/NDA.pdf'],
};
